import { DialogActions, MenuItem } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { Form } from "formik";
import * as Yup from "yup";
import FormikActions from "../formik/formikActions";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import FormikTextField from "../formik/formikTextField";
import CustomDialog from "./customDialog";

const validationSchema = Yup.object({
  nombre: Yup.string()
    .required("Campo obligatorio."),
  nombreCorto: Yup.string()
    .required("Campo obligatorio.")
    .max(5, "No puede ser mayor a 5."),
  integrationUrl: Yup.string()
    .required("Campo obligatorio."),
  nombreCliente: Yup.string()
    .required("Campo obligatorio."),
  integrationApiKey: Yup.string()
    .required("Campo obligatorio."),
  metodoCargaSiniestros: Yup.string()
    .required("Campo obligatorio."),
  codigoSrt: Yup.string()
    .required("Campo obligatorio."),
});

const EditArtDialog = ({
  art,
  openEditar,
  handleCloseEditar,
  addingNewArt,
  handleConfirmEditar,
  isLoadingEditArt,
}) => {

  const initialValues = {
    ...art,
    enviarFormularios: art.enviarFormularios || false,
    enviarTurnos: art.enviarTurnos || false,
  };

  return (
    <CustomDialog
      open={openEditar || isLoadingEditArt}
      onClose={handleCloseEditar}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{addingNewArt ? "Agregar ART" : "Editar ART"}</DialogTitle>
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleConfirmEditar(values)}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
          <Form>

            <DialogContent>
              {values.id && (
                <FormikTextField
                  name="id"
                  margin="dense"
                  label="Id"
                  type="text"
                  fullWidth
                  disabled
                />
              )}
              <FormikTextField
                name="nombre"
                margin="dense"
                label="Razón social"
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
              <FormikTextField
                name="nombreCorto"
                margin="dense"
                label="Nombre corto"
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
              <FormikTextField
                name="integrationUrl"
                margin="dense"
                label="URL Integration"
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
              <FormikTextField
                name="nombreCliente"
                margin="dense"
                label="Nombre Cliente"
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
              <FormikTextField
                name="integrationApiKey"
                margin="dense"
                label="Integration Api Key"
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  control={
                    <Switch
                      name="enviarFormularios"
                      checked={values.enviarFormularios}
                      onChange={handleChange}
                      disabled={isLoadingEditArt}
                    />
                  }
                  label="Envía formularios por mail"
                  labelPlacement="start"
                />
              </FormGroup>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  control={
                    <Switch
                      name="enviarTurnos"
                      checked={values.enviarTurnos}
                      onChange={handleChange}
                      disabled={isLoadingEditArt}
                    />
                  }
                  label="Envía turnos por mail"
                  labelPlacement="start"
                />
              </FormGroup>
              <FormikSelect
                name="metodoCargaSiniestros"
                label="Método de carga de siniestros"
                disabled={isLoadingEditArt}
                required
                margin="dense"
                variant="outlined"
                sx={{ marginTop: 1, marginBottom: 1 }}
              >
                <MenuItem value="F">Fachada</MenuItem>
                <MenuItem value="M">Manual</MenuItem>
              </FormikSelect>
              <FormikTextField
                name="codigoSrt"
                margin="dense"
                label="Código ante la S.R.T."
                type="text"
                fullWidth
                required
                disabled={isLoadingEditArt}
              />
            </DialogContent>
            <DialogActions>
              <FormikActions
                handleCancel={handleCloseEditar}
                disabled={isLoadingEditArt}
              />
            </DialogActions>
          </Form>
        )}
      </FormikForm>
    </CustomDialog>
  );
};

export default EditArtDialog;